export const OPEN_PROBLEMS = [
  {
    id: "extrahepatic-sirna-delivery",
    title: "Extrahepatic siRNA delivery",
    description: "The next GalNAc-scale advance needs more than uptake. We’re interested in connecting targeting, intracellular delivery and functional activity.",
    interest: "scientific-ai",
  },
  {
    id: "multimodal-data-integration",
    title: "Multimodal data integration",
    description: "DNA, RNA, protein and chromatin describe different parts of the same system. How can we combine them into predictions an experiment can test?",
    interest: "data",
  },
  {
    id: "fusion-proteins",
    title: "Fusion proteins",
    description: "How do combinations of protein domains, linkers and geometry change function? We want to explore that design space with experimental teams.",
    interest: "scientific-ai",
  },
  {
    id: "cell-state-prediction",
    title: "Cell-state prediction",
    description: "Which interventions change a cell’s state—and do the predictions hold up in another cell type, donor or condition?",
    interest: "scientific-ai",
  },
  {
    id: "early-safety-signals",
    title: "Earlier safety signals",
    description: "Can molecular measurements flag a candidate’s toxicity earlier? We’re interested in models tested against human-relevant experiments and known safety signals.",
    interest: "scientific-ai",
  },
];
